import { useEffect } from 'react'

import BaseBridge from 'config/bridge/BaseBridge'
import { useHistory } from 'react-router-dom'
import { TypesRoutes } from 'routes/mixedRoutes/mixedRoutes'
import useBoundState from 'store'
import { hasAnyTicket } from 'store/afterSales/handleTickets'

import { Button } from '@interco/inter-ui/components/Button'

import { MyTicketsShimmer } from './MyTickets.shimmer'
import * as S from './MyTickets.styles'
import { MyTicketsAccordionManager } from '../MyTicketsAccordionManager'
import { analyticsMyTicketsTab } from './MyTickets.tags'

// NOSONAR
export const MyTickets = () => {
  const history = useHistory()
  const contentCapitalization = useBoundState((state) => state.contentCapitalization)
  const getTickets = useBoundState((state) => state.getTickets)

  const isLoading = useBoundState((state) => state.isLoading)
  const tickets = useBoundState((state) => state.tickets)

  useEffect(() => {
    BaseBridge.tacWb({
      name: 'after_sales_screen_loaded',
      module: 'capitalizacao',
      actions: ['enter_after_sales'],
      params: {},
    })
  }, [])

  useEffect(() => {
    const HAS_ANY_TICKET = hasAnyTicket(tickets)

    if (!HAS_ANY_TICKET) {
      getTickets({ history, pathname: TypesRoutes.LANDING_PAGE_HOME })
    }

    if (HAS_ANY_TICKET) {
      const HAS_REDEEMABLE_TICKETS = (tickets.totalRedemptionAmount ?? 0) > 0

      analyticsMyTicketsTab({
        display_redemption_available_tag: HAS_REDEEMABLE_TICKETS ? 'true' : 'false',
      })
    }
  }, [history, tickets, getTickets])

  const handleRedirectSales = () => {
    getTickets({ history, pathname: TypesRoutes.LANDING_PAGE_HOME })
  }

  return isLoading ? (
    <MyTicketsShimmer />
  ) : (
    <S.Container data-testid="after-sales-container">
      <S.Tickets>
        <MyTicketsAccordionManager tickets={tickets} />
      </S.Tickets>

      <S.Footer>
        <Button data-testid="pay-button" fullWidth onClick={handleRedirectSales}>
          Comprar uma {contentCapitalization.value1}
        </Button>
      </S.Footer>
    </S.Container>
  )
}
